import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const STORAGE_KEY = 'defend.sidebar.collapsed';

export default function LayoutShell({
  abaAtiva,
  setAbaAtiva,
  permissoes,
  usuario,
  nomePerfil,
  onLogout,
  children,
}) {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch {
      // localStorage indisponível (privacy mode) — ignorar
    }
  }, [collapsed]);

  return (
    <div className="flex h-screen bg-surface-muted overflow-hidden">
      <Sidebar
        abaAtiva={abaAtiva}
        setAbaAtiva={setAbaAtiva}
        permissoes={permissoes}
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((v) => !v)}
      />

      <div className="flex flex-col flex-1 min-w-0">
        <Topbar usuario={usuario} nomePerfil={nomePerfil} onLogout={onLogout} />
        <main className="flex-1 overflow-y-auto">
          <div className="max-w-[1400px] mx-auto px-6 py-6">{children}</div>
        </main>
      </div>
    </div>
  );
}
